import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import { properties } from "../constants/Propertise";

class HelpPage extends Component {

	render() {
		let view = <div />;
		view = (
			<div className="contianer">
				<Col md={12}>
					<div className="page-header">
						<h3 className="pageheader-title">{properties.helpText}</h3>
					</div>
					<br></br><br></br>
					<h3 class="text-center">{properties.contactBelowText}</h3><br></br>
					<h4 class="email text-center">
						<a href="itdc.helpdesk@tatacommunications.com" target="_blank" class="text-primary">
							{properties.contactEmail}
						</a>
					</h4>
					<br></br><h4 class="mob-no text-center">{properties.helpContactNumber}</h4>
					<h1 className="text-right"><img width="200px" src="../images/help.png" alt="helpImage"/></h1>
				</Col>
			</div>
		);
		
		return <div>{view}</div>;
	}
}

export default HelpPage;
